import { compose, withProps } from 'recompose'
import { connect } from 'react-redux'
import { goBack } from 'connected-react-router'
import toggle from 'components/common/hoc/toggle'
import { formatPhoneNumber } from 'helpers/phone-number'
import { getDividedPromotionsList } from './helpers'
import { showPromotionsDetailModalPage } from 'components/PromotionsDetailModalPage/actions'
import QuoteSummary from './QuoteSummary'

const withImprovedProps = withProps(({
  appliedPromotions,
  quoteSummary: {
    instantSavings,
    productAndService
  } = {},
  currentStore: {
    phoneNumbers
  } = {}
}) => ({
  productAndServiceMinusInstantSavings: (parseFloat(productAndService) || 0) + (Math.abs(instantSavings || 0)),
  promotions: getDividedPromotionsList(appliedPromotions),
  storeFormattedPhone: phoneNumbers ? formatPhoneNumber(phoneNumbers[0]) : undefined
})
)

export default compose(
  connect(null, { showPromotionsDetailModalPage, goBack }),
  withImprovedProps,
  toggle
)(QuoteSummary)
